import script from "./CheckIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CheckIcon.vue?vue&type=style&index=0&id=4c772682&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c772682"]])

export default __exports__